export function onBeforePageUnload(event) {
  event.preventDefault()
  event.returnValue = ''
}

